import { http } from '../../api/http.js';

export async function fetchQueues() {
  const res = await http.get('/api/redis/queues');
  return res.data;
}

export async function fetchMachineQueue(machineId) {
  if (!machineId) throw new Error('machineId is required');

  const res = await http.get(`/api/redis/queues/${machineId}`);
  // întoarce tot payload-ul (nu doar groups) ca să ai queueSize, machineId etc.
  return res.data;
}
